import { stringifyFilter } from "colbi_web_ui/lib/utils";

export const mapCard = (json) => {
    const { KpiID, Description, KpiType } = json;
    return [
        [{ labels: ["kpiId"], value: KpiID, type: "string", basis: "20%" }],
        [
            {
                labels: ["description"],
                value: Description,
                type: "string",
                basis: "50%",
            },
        ],
        [
            {
                labels: ["kpiType"],
                value: KpiType,
                type: "number",
            },
        ],
        [{ labels: [], value: ["delete"], type: "user_actions" }],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        checked: json.selected,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: `/:locale(pt|en|lt|es|ro|fr)?/settings/kpis/?filter=${stringifyFilter([
                { column: "KpiID", filters: [{ value: `${json.KpiID}` }] },
            ])}`,
        },
    };
};

const header = [
    {
        label: ["Identifier"],
        align: "left",
        basis: "20%",
        columnName: "KpiID",
        sortable: true,
    },
    {
        label: ["Description"],
        align: "left",
        basis: "50%",
        columnName: "Description",
        sortable: true,
    },
    {
        label: ["Kpi Type"],
        align: "center",
        columnName: "KpiType",
        sortable: true,
    },
    {
        label: ["checkbox"],
        align: "right",
    },
];

const packagesassociationkpisMapper = {
    map: mapper,
    header,
};

export default packagesassociationkpisMapper;
